import { render, staticRenderFns } from "./ServiceRegisterError.vue?vue&type=template&id=39c3b1bc&"
import script from "./ServiceRegisterError.vue?vue&type=script&lang=ts&"
export * from "./ServiceRegisterError.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports